import {SERVER_URL_ISTANZE, SERVER_URL_LOGIN} from "@/requests/common";

export class authApi {

    public static GET_JWT(): string {
        return `${SERVER_URL_LOGIN}/login/jwt`;
    }

    public static GET_CURRENT_USER(): string {
        return `${SERVER_URL_ISTANZE}/user/current`;
    }

    public static UPDATE(emailAlt: string | null, phone: string | null, provincia: string | null): [string, any] {
        return [`${SERVER_URL_ISTANZE}/user/update`, {emailAlt: emailAlt, phone: phone, provincia: provincia}];
    }

    public static UPDATE_USER_CHANNELS(email: boolean, appio: boolean): [string, any] {
        return [`${SERVER_URL_ISTANZE}/user/update/channels`, {email: email, appio: appio}];
    }

    public static UPDATE_TITOLALRE(): string {
        return `${SERVER_URL_ISTANZE}/titolare/create`;
    }

    public static GET_STRUTTURE_UTENTE(): string {
        return `${SERVER_URL_ISTANZE}/user/strutture`;
    }

    public static GET_TITOLARI(active?: boolean, filterText?: string): string {
        if (active == undefined) active = true;
        return `${SERVER_URL_ISTANZE}/user/getTitolari${active ? '?active=false' : '?active=true'}${filterText ? '&filterText=' + filterText : ''}`;
    }

    public static GET_DELEGHE_TITOLARE(titolareId: string): string {
        return `${SERVER_URL_ISTANZE}/titolare/${titolareId}/getDelega`;
    }

    public static GET_TITOLARE_UTENTE(userCf: string, titolareCf: string): string {
        return `${SERVER_URL_ISTANZE}/titolare/find?utente=${userCf}&titolare=${titolareCf}`;
    }

    public static GET_PERSONA_GIURIDICA(code: string): string {
        return `${SERVER_URL_ISTANZE}/titolare/aris?code=${code}`;
    }

    //Titolare
    public static GET_DATI_TITOLARE(titolariId: string | number, tipo: string): string {
        return `${SERVER_URL_ISTANZE}/dati-titolare/all/${titolariId}/${tipo}`;
    }

    public static REVOCA_DELEGA(id: number) {
        return `${SERVER_URL_ISTANZE}/titolare/revocaDelega/${id}`;
    }

    public static UPLOAD_DELEGA(formData: FormData): [string, any] {
        return [`${SERVER_URL_ISTANZE}/titolare/uploadDelega`, formData];

    }

    public static GET_ALEGATO_DELEGA(id: number): string {
        return `${SERVER_URL_ISTANZE}/titolare/downloadDelega/${id}`;

    }

    public static GET_LOGIN_URL(): string {
        return `${SERVER_URL_ISTANZE}/sso/url`
    }

    public static POST_LOGOUT_URL(): string {
        return `${SERVER_URL_LOGIN}/login/logout`
    }

}
